import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TerminalDetailsDto } from '../../../models/terminals/terminalDetailsDto';

interface SoftwareHashesCardProps {
  terminal?: TerminalDetailsDto;
}

export const SoftwareHashesCard: React.FC<SoftwareHashesCardProps> = ({ terminal }) => (
  <Box className="gbr" px={2} pb={2} sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Typography variant="h5" fontWeight="bold" sx={{ pt: 2, pb: 1 }}>
      Эталонные контрольные суммы версии ПО {terminal?.softwareVersion ?? '-'}
    </Typography>
    {terminal?.softwareHashes && terminal.softwareHashes.length > 0 ? (
      <TableContainer
        sx={{
          // 4 строки + заголовок таблицы
          maxHeight: 200,
          overflowY: 'auto',
          overflowX: 'hidden',
          borderRadius: '10px',
          border: '1px solid #e0e0e0',
          borderBottom: 'none'
        }}
      >
        <Table
          size="small"
          stickyHeader
          sx={{
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, fontSize: '14px' }}>Файл</TableCell>
              <TableCell sx={{ fontWeight: 600, fontSize: '14px' }}>Контрольная сумма</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {terminal.softwareHashes.map((hash, index) => (
              <TableRow key={index}>
                <TableCell sx={{ wordBreak: 'break-all' }}>{hash.filePath}</TableCell>
                <TableCell sx={{ wordBreak: 'break-all' }}>{hash.hash}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    ) : (
      <Typography className="grey" variant="body2" mt={1}>
        Нет данных о контрольных суммах
      </Typography>
    )}
  </Box>
);
